// synaxarium.js (or your script.js)

// Guard: we need the JSON url injected from Liquid (see Section B).
(function () {
  var _data = null;
  var _timer = null;

  function start() {
    try {
      var url = window.SYNAXARIUM_ASSETS && window.SYNAXARIUM_ASSETS.jsonUrl;
      if (!url) return show("reading", "Error: Missing JSON URL");

      // Fetch as text first so we can detect HTML responses
      fetch(url, { cache: "no-store" })
        .then(function (res) { return res.text(); })
        .then(function (txt) {
          if (txt.trim().charAt(0) === "<") {
            throw new Error("Got HTML instead of JSON. Check the asset URL: " + url);
          }
          _data = JSON.parse(txt);
          render();
          if (_timer == null) _timer = setInterval(render, 60 * 1000); // re-check every minute
        })
        .catch(function (err) {
          console.error(err);
          show("reading", "Error loading reading.");
        });
    } catch (e) {
      console.error(e);
      show("reading", "Error loading reading.");
    }
  }

  function render() {
    if (!_data) return;
    var effective = nowWith6pmBoundary(new Date());
    var c = toCoptic(effective);
    var key = c.month + "-" + c.day;

    show("date", "Coptic Date: " + c.month + " " + c.day);
    show("reading", _data[key] || "No reading found for today.");
  }

  // After 6:00 PM local time, treat “today” as tomorrow for the Coptic lookup.
  function nowWith6pmBoundary(d) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), 0);
    if (x.getHours() >= 18) x.setDate(x.getDate() + 1);
    return x;
  }

  // Gregorian → Coptic (approximate)
  function toCoptic(date) {
    var y = date.getFullYear();
    var newYear = new Date(y, 8, (isLeapYear(y + 1) ? 12 : 11)); // Sep 11/12
    if (date < newYear) newYear.setFullYear(y - 1);
    var daysSince = Math.floor((date - newYear) / 86400000);
    var monthIndex = Math.floor(daysSince / 30);
    var day = (daysSince % 30) + 1;
    var months = ["Tute","Babah","Hatour","Kiahk","Tubah","Amshir","Baramhat","Baramoudah","Bashans","Baounah","Abib","Misra","El-nasi"];
    return { month: months[monthIndex] || "El-nasi", day: day };
  }
  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

  function show(id, text) {
    var el = document.getElementById(id);
    if (!el) { console.warn("Missing element #"+id); return; }
    el.innerText = text;
  }

  // Start when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
